<template>
  <InteressesLayout>
    <template #cards>
      <v-flex v-for="(card, index) in cards" :key="index" fluid xs4>
        <cbm-card
          :number-text="card.value"
          :title="card.text"
          :boolean-loader="loading"
          :is-currency="card.isCurrency"
          :percent-description="card.underText"
          unset-percentage-colors
          simple-card
        />
      </v-flex>
    </template>
    <template v-slot:table="{ tableList }">
      <mf-loading :loader="['last-update', 'primeiro-registro', 'interesses-por-idade']" loader-type="table" :boolean-loader="loading">
        <v-data-table
          v-if="tableList === 'cupons'"
          :items="orderDescList(listaDeInteressesIdade, 'NUM_ITENS_TOTAL')"
          :items-per-page-options="rowsPerPageArray"
          :headers="headersCupons"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['DES_CATEGORIA'] }}</td>
              <td class="text-center">
                <listagem :nome-categoria="item['DES_CATEGORIA']" :categoria-produto="item['COD_ID_CATEGORIA_PRODUTO']" :value="item['NUM_ITENS_TOTAL']" />
              </td>
              <td v-for="(card, index) in cards" :key="index" class="text-center">
                <listagem
                  :nome-lista="`Faixa-etária ${card.text}`"
                  :nome-categoria="item['DES_CATEGORIA']"
                  :categoria-produto="item['COD_ID_CATEGORIA_PRODUTO']"
                  :categoria-faixa-etaria="index + 1"
                  :value="item[`NUM_ITENS_FE_${index + 1}`]"
                />
              </td>
            </tr>
          </template>
        </v-data-table>

        <v-data-table
          v-else
          :items="orderDescList(listaDeInteressesIdadeValor, 'VAL_FATURAMENTO_TOTAL')"
          :items-per-page-options="rowsPerPageArray"
          :headers="headersFaturamento"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['DES_CATEGORIA'] }}</td>
              <td class="text-center">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
              <td v-for="index in 6" :key="index" class="text-center">{{ item[`VAL_FATURAMENTO_FE_${index}`] | localeString(2) | currency }}</td>
            </tr>
          </template>
        </v-data-table>
      </mf-loading>
    </template>
  </InteressesLayout>
</template>

<script>
import InteressesLayout from '@/modules/clientes/interesses/layouts/Index.vue'
import CbmCard from '@/components/CbmCard.vue'
import Listagem from '@/components/ListagemClientes.vue'
import { assertArray, localeString } from '@/config/helpers.js'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import InteressesMixins from '@/modules/clientes/interesses/mixins/index'

export default {
  components: {
    InteressesLayout,
    CbmCard,
    Listagem,
  },
  mixins: [InteressesMixins],
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState({
      listaDeInteressesIdade: (state) => state.clientes.listaInteressesIdade,
      listaDeInteressesIdadeValor: (state) => state.clientes.listaInteressesIdadeValor,
      stateTicketMedio: (state) => state.clientes.ticketMedio,
      stateFilters: (state) => state.filters,
    }),
    ageGroups() {
      return ['18 - 24', '25 - 34', '35 - 44', '45 - 54', '55 - 64', '65 +']
    },
    cards() {
      const values = [
        {
          value: this.ticketMedio.eighteen || 0,
        },
        {
          value: this.ticketMedio.twentyfive || 0,
        },
        {
          value: this.ticketMedio.thirtyfive || 0,
        },
        {
          value: this.ticketMedio.fortyfive || 0,
        },
        {
          value: this.ticketMedio.fiftyfive || 0,
        },
        {
          value: this.ticketMedio.sixtyfiveplus || 0,
        },
      ]
      return this.ageGroups.map((age, index) => {
        return {
          text: age,
          value: localeString(values[index].value || 0, 2),
          isCurrency: true,
          underText: 'Ticket médio',
          loader: ['last-update', 'primeiro-registro', 'ticket-medio', 'ticket-medio-object'],
        }
      })
    },
    ticketMedio() {
      this.$wait.start('ticket-medio-object')
      let object = {}
      for (let state of assertArray(this.stateTicketMedio)) {
        switch (state['NUM_FAIXA_ETARIA']) {
          case 1:
            object.eighteen = state['VAL_TICKET_MEDIO']
            break
          case 2:
            object.twentyfive = state['VAL_TICKET_MEDIO']
            break
          case 3:
            object.thirtyfive = state['VAL_TICKET_MEDIO']
            break
          case 4:
            object.fortyfive = state['VAL_TICKET_MEDIO']
            break
          case 5:
            object.fiftyfive = state['VAL_TICKET_MEDIO']
            break
          case 6:
            object.sixtyfiveplus = state['VAL_TICKET_MEDIO']
            break
        }
      }
      this.$wait.end('ticket-medio-object')
      return object
    },
    headersCupons() {
      return [
        {
          text: 'Categorias',
          value: 'DES_CATEGORIA',
        },
        {
          text: 'Quantidade total',
          align: 'center',
          value: 'NUM_ITENS_TOTAL',
        },
        {
          text: '18 - 24',
          align: 'center',
          value: 'NUM_ITENS_FE_1',
        },
        {
          text: '25 - 34',
          align: 'center',
          value: 'NUM_ITENS_FE_2',
        },
        {
          text: '35 - 44',
          align: 'center',
          value: 'NUM_ITENS_FE_3',
        },
        {
          text: '45 - 54',
          align: 'center',
          value: 'NUM_ITENS_FE_4',
        },
        {
          text: '55 - 64',
          align: 'center',
          value: 'NUM_ITENS_FE_5',
        },
        {
          text: '65+',
          align: 'center',
          value: 'NUM_ITENS_FE_6',
        },
      ]
    },
    headersFaturamento() {
      return [
        {
          text: 'Categorias',
          value: 'DES_CATEGORIA',
        },
        {
          text: 'Faturamento total',
          align: 'center',
          value: 'VAL_FATURAMENTO_TOTAL',
        },
        {
          text: '18 - 24',
          align: 'center',
          value: 'VAL_FATURAMENTO_FE_1',
        },
        {
          text: '25 - 34',
          align: 'center',
          value: 'VAL_FATURAMENTO_FE_2',
        },
        {
          text: '35 - 44',
          align: 'center',
          value: 'VAL_FATURAMENTO_FE_3',
        },
        {
          text: '45 - 54',
          align: 'center',
          value: 'VAL_FATURAMENTO_FE_4',
        },
        {
          text: '55 - 64',
          align: 'center',
          value: 'VAL_FATURAMENTO_FE_5',
        },
        {
          text: '65+',
          align: 'center',
          value: 'VAL_FATURAMENTO_FE_6',
        },
      ]
    },
  },
  async mounted() {
    this.loading = true
    await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
      this.setFilters({ ...this.stateFilters, pessoa: '' })
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      listaInteressesPorIdade: 'interesses-por-idade',
      listaInteressesPorIdadeValor: 'interesses-por-idade-valor',
      clientesTicketMedio: 'ticket-medio',
      setFilters: 'set-filters',
      empresaPrimeiroRegistro: 'primeiro-registro',
    }),
    async getData() {
      if (this.stateFilters.data?.[0].length > 0) {
        try {
          this.loading = true
          const filter = {
            unidades: this.stateFilters.unitsConfiguration,
            tipo_pessoa: 'F',
            categoria_cliente: this.stateFilters.cliente,
            fidelidade: this.stateFilters.fidelidade,
            segmentos: this.stateFilters.segmentos,
            date: this.stateFilters.data,
          }

          await this.listaInteressesPorIdade(filter)
          await this.listaInteressesPorIdadeValor(filter)
          await this.clientesTicketMedio({ ...filter, group_field: 'faixa_etaria' })
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      }
    },
  },
}
</script>
